module.exports = __webpack_public_path__ + "static/media/add_icon_round.6b177768.svg";